import script from "./TrendView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendView.vue?vue&type=script&setup=true&lang=js"

import "./TrendView.vue?vue&type=style&index=0&id=e14af1f4&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14af1f4"]])

export default __exports__